const mytripsItinerary = require('./mytrips_itinerary');
const confirmationItinerary = require('./confirmation_itinerary');

const cache = {};

function itineraryFactory(bookingData) {
    const bookingId = Odigeo._.get(bookingData, 'bookingBasicInfo.id') || Odigeo._.get(bookingData, 'bookingId');

    if (isItineraryNotCached(bookingId)) {
        cache[bookingId] = isMytripsDto(bookingData) ? mytripsItinerary(bookingData) : confirmationItinerary(bookingData);
    }

    return cache[bookingId];
}

function isItineraryNotCached(bookingId) {
    return !cache[bookingId];
}

function isMytripsDto(dto) {
    return {}.hasOwnProperty.call(dto, 'bookingBasicInfo') && {}.hasOwnProperty.call(dto, 'itineraryBookings');
}

module.exports = itineraryFactory;
